import { useQuery, UseQueryOptions } from "react-query";
import { Url } from "@edgetier/types";
import { AxiosError } from "axios";
import axios from "utilities/axios";
import { IAuthMethod } from "types-for/auth/auth-method.types";

/**
 * Request auth methods from API
 * @param url               Route URL
 * @param queryParameters   Route query parameters
 */
const requestAuthMethods = async (url: string, queryParameters: {}) => {
    const { data } = await axios.get(url, { params: queryParameters });

    if ("items" in data) {
        return data.items;
    } else {
        return data;
    }
};

/**
 * Hook to request authentication methods. Includes a retry delay
 * @param queryParameters   Optional query parameters.
 * @param options           React query options
 */
const useAuthMethods = <T = IAuthMethod[]>(
    queryParameters: {} = {},
    options: Omit<UseQueryOptions<IAuthMethod[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Url.AuthMethods;

    return useQuery<IAuthMethod[], AxiosError, T>(
        [url, queryParameters],
        () => requestAuthMethods(url, queryParameters),
        options
    );
};

export default useAuthMethods;
